/**
 * Drilldown Menu (mobile)
 * Submenus slide over the parent menu as a full overlay.
 * The open class is set on the parent li, and CSS animates the child ul.
 */

const CLASSES = {
  open: 'is-drilldown-open',
  back: 'js-drilldown-back',
};

function init() {
  const menu = document.querySelector('[data-drilldown]');
  if (!menu) return;

  const backLabel = menu.dataset.backButton || 'Hoofdmenu';

  menu.querySelectorAll('li').forEach((li) => {
    const submenu = li.querySelector(':scope > ul');
    if (!submenu) return;

    const link = li.querySelector(':scope > a, :scope > span');
    if (!link) return;

    // Create forward trigger
    const forwardBtn = document.createElement('button');
    forwardBtn.className = 'drilldown-forward';
    forwardBtn.setAttribute('aria-label', `Open submenu ${link.textContent.trim()}`);
    forwardBtn.setAttribute('type', 'button');
    forwardBtn.innerHTML = '<span aria-hidden="true">&rsaquo;</span>';
    li.appendChild(forwardBtn);

    // Create back button at the top of submenu
    const backLi = document.createElement('li');
    backLi.className = CLASSES.back;
    const backBtn = document.createElement('button');
    backBtn.setAttribute('type', 'button');
    backBtn.setAttribute('tabindex', '0');
    backBtn.textContent = backLabel;
    backLi.appendChild(backBtn);
    submenu.prepend(backLi);

    // Add parent link in submenu
    if (link.tagName === 'A' && link.href) {
      const parentLinkLi = document.createElement('li');
      parentLinkLi.className = 'drilldown-parent-link';
      const parentLink = link.cloneNode(true);
      parentLinkLi.appendChild(parentLink);
      backLi.after(parentLinkLi);
    }

    function openSubmenu() {
      li.classList.add(CLASSES.open);
    }

    forwardBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openSubmenu();
    });

    link.addEventListener('click', (e) => {
      if (!li.classList.contains(CLASSES.open)) {
        e.preventDefault();
        openSubmenu();
      }
    });

    // Close: remove class from parent li
    backBtn.addEventListener('click', (e) => {
      e.preventDefault();
      li.classList.remove(CLASSES.open);
      requestAnimationFrame(() => forwardBtn.focus());
    });
  });

  menu.setAttribute('role', 'navigation');
  menu.setAttribute('aria-label', 'Mobile menu');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
